// Label keys for offer type display — keyed by lowercased incentiveType from ice-pack data
// Keys match V9 i18n service: INCENTIVES_${type with underscores removed}_OFFERS
const OFFER_TYPE_LABEL_KEYS = {
	apr: 'INCENTIVES_APR_OFFERS',
	cash_and_apr: 'INCENTIVES_CASHANDAPR_OFFERS',
	cash: 'INCENTIVES_CASH_OFFERS',
	lease: 'INCENTIVES_LEASE_OFFERS',
	promotion: 'INCENTIVES_PROMOTION_OFFERS',
	cash_or_apr: 'INCENTIVES_CASHORAPR_OFFERS',
	apr_undef: 'INCENTIVES_APRUNDEF_OFFERS'
};

export default OFFER_TYPE_LABEL_KEYS;
